<template>
  <div>
    <v-hover v-slot="{ hover }">
      <div class="text-caption">
        <iri-value :iri="name" :highlights="highlights" humanize>{{
          hover
        }}</iri-value>
      </div>
    </v-hover>
    <div v-if="isEmpty" class="body-text text--disabled mb-1">Empty</div>
    <div v-for="(v, index) of dataProperty.values" :key="index" class="mb-1">
      <!-- Geo coordinate literals use GeoCoordinateValue component -->
      <geo-coordinate-value
        v-if="isGeoCoordinateLiteral(dataProperty.values[index])"
        :literal="dataProperty.values[index]"
        :highlights="highlights"
        :edit="edit"
        @input="onInput(index, $event)"
        @delete="onDelete"
      ></geo-coordinate-value>
      <!-- JSON literals use JsonValue component -->
      <json-value
        v-else-if="isJsonLiteral(dataProperty.values[index])"
        :jsonLiteral="dataProperty.values[index]"
        :edit="edit"
        @input="onInput(index, $event)"
        @delete="onDelete"
      ></json-value>
      <!-- DateTime/Date literals use DateTimeValue component -->
      <date-time-value
        v-else-if="isDateTimeLiteral(dataProperty.values[index])"
        :literal="dataProperty.values[index]"
        :highlights="highlights"
        :edit="edit"
        @input="onInput(index, $event)"
        @delete="onDelete"
      ></date-time-value>
      <!-- Regular literals use LiteralValue component -->
      <literal-value
        v-else
        :literal="dataProperty.values[index]"
        :highlights="highlights"
        :edit="edit"
        @input="onInput(index, $event)"
        @delete="onDelete"
      ></literal-value>
    </div>
  </div>
</template>

<script>
// TODO temporary solution removing support for geocoordinates
// For editing different compoennt types are needed, eg string, geocoord, float/double, integer...

// TODO add scroll with blur similar to object property for large data property values, eg Geometries GML.
import IriValue from './IriValue.vue'
import LiteralValue from './LiteralValue.vue'
import JsonValue from './JsonValue.vue'
import DateTimeValue from './DateTimeValue.vue'
import GeoCoordinateValue from './GeoCoordinateValue.vue'

import { DataProperty, Iris /*, Literal */ } from '@/rec-cache/rec-cache-types'

export default {
  // TODO refactor literal geocoords into own component after all.
  // TODO add config flag for conversions of data properties. May be done with date-time as well.

  components: {
    IriValue,
    LiteralValue,
    JsonValue,
    DateTimeValue,
    GeoCoordinateValue,
  },

  props: {
    dataProperty: {
      type: Object,
      default: () => {
        return new DataProperty()
      },
    },
    highlights: {
      type: [String, Array],
      default: () => {
        return []
      },
    },
    edit: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({}),
  watch: {},

  computed: {
    name: function () {
      return this.dataProperty.name
    },
    isEmpty: function () {
      return this.dataProperty.isEmpty
    },
    // TODO remniscence from previous, managing of value types will be moved into the literal at later stage.
    // isCoordinates: function () {
    //   return this.name.value == Iris.recCoordinates
    // },
  },
  created: function () {},
  methods: {
    isJsonLiteral(literal) {
      return literal.datatype === Iris.rdfJSON
    },
    isDateTimeLiteral(literal) {
      return (
        literal.datatype === Iris.xsdDateTime ||
        literal.datatype === Iris.xsdDate
      )
    },
    isGeoCoordinateLiteral(literal) {
      // Geo coordinates can be stored as either:
      // 1. rdf:JSON datatype (new style)
      // 2. xsd:string with JSON array content (legacy)
      // We identify them by the property name being rec:coordinates
      const isCoordinatesProperty =
        this.dataProperty.name.value === Iris.recCoordinates

      // If it's the coordinates property, check if value looks like a JSON array
      if (isCoordinatesProperty) {
        try {
          const parsed = JSON.parse(literal.value)
          // Valid coordinates are arrays with 2 numbers [longitude, latitude]
          return (
            Array.isArray(parsed) &&
            parsed.length === 2 &&
            typeof parsed[0] === 'number' &&
            typeof parsed[1] === 'number'
          )
        } catch (e) {
          return false
        }
      }

      return false
    },
    onInput: function (index, newLiteral) {
      this.dataProperty.setValue(index, newLiteral)
    },
    onDelete: function (literal) {
      if (this.edit && this.dataProperty.isOne) {
        // Remove the data property if only one value is set
        this.$emit('delete', this.dataProperty)
      } else {
        // TODO remove the specific literal, could be done with the index too, either ways this implementaiton doesnt support multi value on data property...
        this.dataProperty.removeValue(literal)
      }
    },
  },
}
</script>
